export default (props, vars) =>
  vars?.['defaultbox145']?.['item']?.['status'] === 'COMPLETED';
